var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMultiUsers(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 7.99967C14.7956 7.99967 15.5587 7.68361 16.1213 7.12103C16.6839 6.55845 17 5.79542 17 4.99981C17 4.2042 16.6839 3.44117 16.1213 2.87859C15.5587 2.31601 14.7956 1.99995 14 1.99995M17 12.9994C18.754 13.3844 20 14.3584 20 15.4993C20 16.5293 18.986 17.4222 17.5 17.8692M12 4.99981C12 7.20884 10.2091 8.99962 8 8.99962C5.79086 8.99962 4 7.20884 4 4.99981C4 2.79078 5.79086 1 8 1C10.2091 1 12 2.79078 12 4.99981ZM15 15.9993C15 18.2083 11.866 19.9991 8 19.9991C4.13401 19.9991 1 18.2083 1 15.9993C1 13.7903 4.13401 11.9995 8 11.9995C11.866 11.9995 15 13.7903 15 15.9993Z",
    stroke: "currentColor",
    strokeWidth: 1.1,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiUsers);
export default __webpack_public_path__ + "static/media/multiUsers.6829a2d95a5268eb45e9bd287f73c7b6.svg";
export { ForwardRef as ReactComponent };